import moment from 'moment';

import { ISchedule, IScheduleWorkHours, WeekDays } from '../models';
import { setWholeDayForAlreadyExistsSchedule } from './set-whole-day-schedule';

export function getOtherSchedulesWorkHours(schedule: ISchedule): IScheduleWorkHours[] {
  const {hours} = schedule;
  const schHours: IScheduleWorkHours[] = [];
  const dateStr = '1970-01-01';
  const dateStrNextDay = '1970-01-02';
  const dateFmt = 'YYYY-MM-DD HH:mm';

  for (const day in hours) {
    const weekDay = day as WeekDays;
    const {closed, nextDay} = hours[day];
    const scheduleHours = setWholeDayForAlreadyExistsSchedule(hours[day]);
    const hasTwoRanges = scheduleHours.length > 1;
    let result = {} as IScheduleWorkHours;

    const baseRange = scheduleHours[0].reduce((acc, elem, i) => {
      const rangeKey = i === 0 ? 'from' : 'to';
      const nextDayForBaseRange = i > 0 && !hasTwoRanges && nextDay;
      acc = {
        ...acc,
        [rangeKey]: moment.utc(`${nextDayForBaseRange ? dateStrNextDay : dateStr} ${elem.hours}:${elem.minutes}`, dateFmt).valueOf(),
      };

      return acc;
    }, {});

    if (hasTwoRanges) {
      const additionalRange = scheduleHours[1].reduce((acc, elem, i) => {
        const rangeKey = i === 0 ? 'from' : 'to';
        acc = {
          ...acc,
          [rangeKey]: moment.utc(`${i > 0 && nextDay ? dateStrNextDay : dateStr} ${elem.hours}:${elem.minutes}`, dateFmt).valueOf(),
        };

        return acc;
      }, {});

      result = { ...result, additionalRange };
    }

    result = { ...result, baseRange, closed, day: weekDay };
    schHours.push(result);
  }

  return schHours;
}
